module.exports = __webpack_public_path__ + "static/media/ISO.2114de15.jpg";